import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { RouterProvider } from 'react-router-dom';

import { store } from '@app/store';
import { AppRouter } from '@app/Routes';
import { config } from '@shared/lib/config';

export const ProviderBase = () => {
  return (
    <>
      <Provider store={store}>
        <GoogleOAuthProvider clientId={config.OAUTH_CLIENT_ID}>
          <RouterProvider router={AppRouter} />
        </GoogleOAuthProvider>
      </Provider>
    </>
  );
};
